import { createSlice } from "@reduxjs/toolkit"

const users = createSlice({
    name: 'usersSlice',
    initialState: [{
        rows: [],
        count: 0,
        loading: false,
        filter: {},
        selectedKeys: [],
    }],
    reducers: {
        getUsersSlice: (state, action) => {
            state = action.payload
            return state
        },
        
        addUserSlice: (state, action) => {
            state.push(action.payload)
            return state
        },
        editUserSlice: (state, action) => {
            state = state.map(i => i.id == action.payload.id ? action.payload : i)
            return state
        }
    }
})

export const { getUsersSlice, addUserSlice, editUserSlice } = users.actions

export default users.reducer 